var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 13,
    height: 13,
    rx: 6.5,
    stroke: "#FB3559"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32909 8.90283C6.33854 7.66532 6.70696 7.28745 7.33044 6.90013C7.7272 6.65452 8.0295 6.31444 8.0295 5.81377C8.0295 5.21862 7.57606 4.8502 7.00926 4.8502C6.49913 4.8502 6.00791 5.16194 5.96067 5.861H4.94043C4.97822 4.66127 5.8851 4 7.00926 4C8.23733 4 9.05919 4.73684 9.05919 5.81377C9.05919 6.5695 8.70021 7.07962 8.09563 7.44804C7.52882 7.78812 7.31155 8.13765 7.29266 8.90283V8.95951H6.32909V8.90283ZM6.84866 11C6.48024 11 6.1685 10.6977 6.17795 10.3293C6.1685 9.96086 6.48024 9.65857 6.84866 9.65857C7.20764 9.65857 7.51938 9.96086 7.51938 10.3293C7.51938 10.6977 7.20764 11 6.84866 11Z",
    fill: "#FB3559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon_question.6c5d652a7d5701a8f8e1e686cf952dab.svg";
export { ForwardRef as ReactComponent };